import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { UpdateAmountAndTermRequest } from '@core/model/update-amount-and-term-request';

@Injectable({
  providedIn: 'root',
})
export class LoanApplicationService {
  apiUrl = environment.apiGatewayUrl;
  updateAmountAndTermUrl = `${this.apiUrl}loanapplication-management-service/loan-application/update/amount/term`;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public updateAmountAndTerm(updateAmountAndTermRequest: UpdateAmountAndTermRequest): Observable<boolean> {
    return this.http
      .post(this.updateAmountAndTermUrl, updateAmountAndTermRequest, {
        headers: this.headers,
      })
      .pipe(
        map((response: boolean) => {
          return response;
        })
      );
  }
}
